import React from 'react';
import classNames from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const MemberTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'MemberTeaser');

  return (
    <div className={classes}>
      <CoreLink to={entity.getIn(['paths', 'nl'])} className="overlapping-link" />
      <div className="MemberTeaser__content">
        <h3>{entity.getIn(['title', 0, 'value'])}</h3>
        {entity.getIn(['field_website', 0, 'uri']) ? (
          <div className="MemberTeaser__row MemberTeaser__website">
            <CoreLink to={entity.getIn(['field_website', 0, 'uri'])} title={entity.getIn(['field_website', 0, 'uri'])} />
          </div>
        ) : null}
        {entity.getIn(['field_telephone_number', 0, 'value']) ? (
          <div className="MemberTeaser__row">
            <i className="icon-before icon-phone" />
            <span>{entity.getIn(['field_telephone_number', 0, 'value'])}</span>
          </div>
        ) : null}
        {entity.getIn(['field_email', 0, 'value']) ? (
          <div className="MemberTeaser__row MemberTeaser__email">
            <i className="icon-before icon-mail" />
            <a href={`mailto:${entity.getIn(['field_email', 0, 'value'])}`} target="_blank" rel="noopener noreferrer">{entity.getIn(['field_email', 0, 'value'])}</a>
          </div>
        ) : null}
        {entity.get('field_address') ? (
          <div className="MemberTeaser__row">
            <i className="icon-before icon-point" />
            <div className="MemberTeaser__row__content">
              <span>{entity.getIn(['field_address', 0, 'address_line1'])}</span>
              <span>{entity.getIn(['field_address', 0, 'postal_code'])} {entity.getIn(['field_address', 0, 'locality'])}</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MemberTeaser;
